import { IconButton, TableCell, TableRow } from "@material-ui/core";
import { Check, Close, KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import React from "react";
import { ICompanyEnvironmentIntegration } from "../../../../models/ICompanyEnvironment";
import { getBoolIcon } from "../../functions/getBool";

interface IEnvironmentRowProps {
  ea: ICompanyEnvironmentIntegration;
  objectFieldsOpen: boolean | undefined;
  toggleAccessesOpen: (obj: ICompanyEnvironmentIntegration) => () => void;
}

export const getEnvironmentRow = (props: IEnvironmentRowProps) => {
  const { ea, objectFieldsOpen, toggleAccessesOpen } = props;

  return (
    <TableRow>
      <TableCell>{ea.Name}</TableCell>
      <TableCell>{`${ea.Url}API`}</TableCell>
      <TableCell>{getBoolIcon(ea.IsDevelopmentEnvironment)}</TableCell>
      <TableCell>
        <IconButton aria-label="expand fields" size="small" onClick={toggleAccessesOpen(ea)}>
          {objectFieldsOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          Details
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
